<nz-modal (nzOnCancel)="closeModal('tender')" [(nzVisible)]="displayModal" [nzClosable]="true" [nzStyle]="tenderModalStyle"
		  nzCentered>
	<div *nzModalTitle class="font-600">
		{{ "global.buyer.shop.add_to_tender" | translate }}
	</div>
	<ng-container *nzModalContent>
		<div class="center">
			<div>
				<button (click)="addNewTender()" [nzSize]="'large'" class="button-grey border-radius-5 grey-border-1"
						nz-button>
					<i nz-icon nzType="plus"></i>{{ "global.buyer.shop.add_new_tender" | translate }}</button>
			</div>
		</div>
		<div class="mt-1">
			<div nz-row>
				<div nz-col nzSpan="20">
					<div class="white-space-nowrap" nz-col nzSpan="4">
						<b>{{ "global.buyer.shop.choose_tender" | translate }}</b>
					</div>
				</div>
			</div>
			<div class="local-danger text-center mt-0_5">
				<span *ngIf="categoryNotMatched">
					{{ ("global.errors.category_not_matched" | translate) }} <br />
					{{ ' "' + selectedDraftTenderName + '" ' }}
				</span>
			</div>
			<div class="mt-1" nz-row>
				<div nz-col nzSpan="24">
					<nz-table #basicTable (nzQueryParams)="onQueryParamsChange($event)" [nzData]="draftTenders" [nzFrontPagination]="false"
							  [nzNoResult]="'global.buyer.tender.no_tenders_found' | translate"
							  [nzPageIndex]="draftTendersState.paginator.page" [nzPageSize]="5"
							  [nzTotal]="totalDraftTenders">
						<thead>
						<tr>
							<th *ngFor="let column of tenderTableColumns" [nzWidth]="column?.width">
								<span class="color-grey">{{ column.title }}</span>
							</th>
						</tr>
						</thead>
						<tbody>
						<tr *ngFor="let data of basicTable.data" class="editable-row"
							style="line-height: 15px; padding: 10px !important">
							<td *ngIf="!data.customAdded">{{ data.name }}</td>
							<td *ngIf="data.customAdded">
								<div (change)="checkForNullEntries('name')" (click)="startEdit(data, 'name', 'create')"
									 [hidden]="createId === data.id" class="editable-cell">
									{{ data.name }}
								</div>
								<input (change)="checkForNullEntries('name')" (nzBlur)="stopEdit('create')" [(ngModel)]="data.name"
									   [hidden]="createId !== data.id" name="name" ngDefaultControl
									   nz-input nzSize="large">
							</td>
							<td>
								<div (change)="checkForNullEntries('volume')" (click)="startEdit(data, 'volume', 'edit')"
									 [hidden]="editId === data.id"
									 class="editable-cell">
									{{ data.volume }}
								</div>
								<nz-input-number (change)="checkForNullEntries('volume')" (nzBlur)="stopEdit('edit', data)" [(ngModel)]="data.volume"
												 [hidden]="editId !== data.id" nz-input
												 nzSize="large"
												 type="number"></nz-input-number>
								<!-- <div style="padding-top: 10px;">
									<span
										*ngIf="!(data?.volume < selectedProduct?.minimumOrderVolume)"> {{ "global.common.minimum_order_volume" | translate }}
										: {{ selectedProduct?.minimumOrderVolume || 1 }} </span>
									<span *ngIf="data?.volume < selectedProduct?.minimumOrderVolume" class="color-danger">
													{{ "global.buyer.cart.minimum_order_volume_required" | translate }} {{ selectedProduct?.minimumOrderVolume || 1 }}
											</span>
								</div> -->
							</td>
							<td>
								<button (click)="addToTender(data)" *ngIf="!data.added" class="border-radius-5 grey-border-1"
										nz-button>
									<i nz-icon nzType="plus"></i>{{ "global.buyer.shop.add" | translate }}</button>
								<button *ngIf="data.added" class="border-radius-5 color-green btn-green-outline"
										nz-button>
									<i nz-icon nzTheme="outline" nzType="check"></i>{{ "global.buyer.shop.added" |
									translate }}</button>
							</td>
						</tr>
						</tbody>
					</nz-table>
				</div>
			</div>
		</div>
	</ng-container>
	<div *nzModalFooter>
		<button (click)="closeModal('tender')" class="button-grey"
				nz-button>{{ "global.buyer.shop.back" | translate }}</button>
	</div>
</nz-modal>
